// extracted by mini-css-extract-plugin
module.exports = {"GaleriaCartagena":"GaleriaCartagena_GaleriaCartagena__18aNP","Image":"GaleriaCartagena_Image__2MLp3"};